<script setup lang="ts">
import OtherFiltersFilter from '@pages/search/components/filters/OtherFiltersFilter.vue';
import type { MobileFilterType } from '@stores/useFilterStore.ts';
import { computed, type Component } from 'vue';
import TeamSizeFilter from '@pages/search/components/filters/TeamSizeFilter.vue';
import OfficeTypeFilter from '@pages/search/components/filters/OfficeTypeFilter.vue';
import { FilterType } from '@enums/FilterType.ts';
import MobileFilterButtonList from '@pages/search/components/filters/MobileFilterButtonList.vue';
import LocationFilter from '@pages/search/components/filters/LocationFilter.vue';

const { currentMobileFilterStep } = defineProps<{
  currentMobileFilterStep: MobileFilterType;
}>();

const activeComponent = computed<Component | null>(() => {
  if (currentMobileFilterStep === 'mobile_filters') {
    return MobileFilterButtonList;
  }

  if (currentMobileFilterStep === FilterType.LOCATION) {
    return LocationFilter;
  }

  if (currentMobileFilterStep === FilterType.CAPACITY) {
    return TeamSizeFilter;
  }

  if (currentMobileFilterStep === FilterType.OFFICE_TYPE) {
    return OfficeTypeFilter;
  }

  if (currentMobileFilterStep === FilterType.OTHER_FILTERS) {
    return OtherFiltersFilter;
  }

  return null;
});
</script>

<template>
  <component :is="activeComponent" />
</template>
